import { useState } from "react";
import { NotificationParams } from "../types/common";

export const useNotification = () => {
    const [notification, setNotification] = useState<NotificationParams>({
        severity: "error",
        message: "",
    });
    const [openSnackbar, setOpenSnackbar] = useState(false);

    return { notification, setNotification, openSnackbar, setOpenSnackbar };
};
